(function () {
  function parseStories(root) {
    var dataNode = root.querySelector('[data-lig-data]');
    if (!dataNode) return [];
    try {
      return JSON.parse(dataNode.textContent).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function init(root) {
    if (!root || root.dataset.ligReady === 'true') return;
    root.dataset.ligReady = 'true';

    var stories = parseStories(root);
    var modal = root.querySelector('[data-lig-modal]');
    var closeButton = root.querySelector('[data-lig-close]');
    var prevButton = root.querySelector('[data-lig-prev]');
    var nextButton = root.querySelector('[data-lig-next]');
    var modalImage = root.querySelector('[data-lig-modal-image]');
    var modalCreator = root.querySelector('[data-lig-modal-creator]');
    var modalTitle = root.querySelector('[data-lig-modal-title]');
    var modalText = root.querySelector('[data-lig-modal-text]');
    var modalProduct = root.querySelector('[data-lig-modal-product]');
    var addButton = root.querySelector('[data-lig-add-look]');
    var addStatus = root.querySelector('[data-lig-add-status]');
    var activeIndex = 0;
    var activeTrigger = null;

    if (!modal || !closeButton || !stories.length) return;

    function processInstagramEmbeds() {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }
      if (document.querySelector('script[data-lig-instagram-embed]')) return;
      var script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.defer = true;
      script.dataset.ligInstagramEmbed = 'true';
      document.body.appendChild(script);
    }

    function scheduleInstagramEmbeds() {
      if (!root.querySelector('.instagram-media')) return;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(processInstagramEmbeds, { timeout: 1800 });
      } else {
        window.setTimeout(processInstagramEmbeds, 800);
      }
    }

    function render(index) {
      var story = stories[index];
      if (!story) return;
      activeIndex = index;
      if (modalImage) {
        modalImage.innerHTML = story.imageHtml || '';
        if (story.imageHtml && story.imageHtml.indexOf('instagram-media') > -1) {
          processInstagramEmbeds();
        }
      }
      if (modalCreator) {
        modalCreator.textContent = [story.creator, story.handle].filter(Boolean).join(' ');
      }
      if (modalTitle) modalTitle.textContent = story.title || '';
      if (modalText) modalText.textContent = story.text || '';
      if (modalProduct) modalProduct.innerHTML = story.productHtml || '';
      if (addStatus) addStatus.textContent = '';
      if (addButton) {
        addButton.disabled = !modalProduct || !modalProduct.querySelector('[data-lig-variant-select]:not(:disabled)');
        addButton.textContent = 'Add selected to bag';
      }
    }

    function open(id, trigger) {
      var index = stories.findIndex(function (story) {
        return story.id === id;
      });
      if (index < 0) return;
      activeTrigger = trigger;
      render(index);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (activeTrigger) activeTrigger.focus();
    }

    root.querySelectorAll('[data-lig-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        open(button.dataset.ligOpen, button);
      });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(button.dataset.ligOpen, button);
      });
    });

    closeButton.addEventListener('click', close);
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        render((activeIndex - 1 + stories.length) % stories.length);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        render((activeIndex + 1) % stories.length);
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!modalProduct || addButton.disabled) return;
        var items = Array.prototype.slice.call(modalProduct.querySelectorAll('[data-lig-variant-select]'))
          .map(function (select) {
            var option = select.selectedOptions && select.selectedOptions[0];
            if (select.disabled || (option && option.disabled)) return 0;
            return Number(select.value);
          })
          .filter(Boolean)
          .map(function (id) {
            return { id: id, quantity: 1 };
          });

        if (!items.length) {
          if (addStatus) addStatus.textContent = 'Please select available products.';
          return;
        }

        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        if (addStatus) addStatus.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            addButton.textContent = 'Added to bag';
            if (addStatus) addStatus.textContent = 'Added to cart.';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('lintico:look-added', { detail: { items: items } }));
          })
          .catch(function () {
            addButton.disabled = false;
            addButton.textContent = 'Add selected to bag';
            if (addStatus) addStatus.textContent = 'Unable to add. Please check product availability.';
          });
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) close();
    });

    root.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') render((activeIndex - 1 + stories.length) % stories.length);
      if (event.key === 'ArrowRight') render((activeIndex + 1) % stories.length);
    });

    scheduleInstagramEmbeds();
  }

  function initAll() {
    document.querySelectorAll('[data-lintico-influencer-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-lintico-influencer-gallery]'));
  });
})();
